const fetchPagePartialSheetData = require('./fetcher');
const PagePartialSheetData = require('./sheet-data');
const { extractTemplate } = require('./syntax');

module.exports = { fetchPagePartialSheetData, PagePartialSheetData, extractTemplate };
